/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Currentklassenstufe1Inputs */



/**

* @param {_Field_Currentklassenstufe1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_currentklassenstufe1 = /** @type {((inputs?: _Field_Currentklassenstufe1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Currentklassenstufe1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Aktuelle Klassenstufe")
});
export { _field_currentklassenstufe1 as "_field_currentKlassenstufe" }